// components/model/ModelGrid.jsx
import React from "react";
import ModelCard from "./ModelCard";
import { useNavigate } from "react-router-dom";
import { PRODUCT_ROUTE, CITY_PRODUCT_ROUTE } from "../../routes/constant";

const ModelGrid = ({ brand, products, isDarkMode, category, city }) => {
  const navigate = useNavigate();

  if (!Array.isArray(products)) {
    console.warn("Products is not an array:", products);
    return null;
  }

  const handleProductClick = (categorySlug, brandSlug, productSlug) => {
    if (city?.slug) {
      navigate(CITY_PRODUCT_ROUTE(city.slug, categorySlug, brandSlug, productSlug));
    } else {
      navigate(PRODUCT_ROUTE(categorySlug, brandSlug, productSlug));
    }
  };

  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10">
      {products.map((product, index) => {
        return (
          <ModelCard
            key={product?.id || index}
            product={product}
            isDarkMode={isDarkMode}
            onClick={() => handleProductClick(category?.slug, brand?.slug, product?.slug)}
          />
        );
      })}
    </div>
  );
};

export default ModelGrid;